export function getAbbreviatedName(name: string) {
    let initials: any = name.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    return initials;
}

export function getNomeSobrenome(name: string) {
    const nomes = name.split(' ');
    return `${((nomes.shift() || ''))} ${(nomes.pop() || '').toUpperCase()}`;
}